import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';
import { COMPANY_NAME } from '../appsettings';

const styles = StyleSheet.create({
    page: {
        padding: 20,
        backgroundColor: '#ffffff',
    },
    header: {
        marginBottom: 15,
        borderBottomWidth: 1,
        borderBottomColor: '#333',
        paddingBottom: 10,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#1a1a1a',
    },
    subtitle: {
        fontSize: 10,
        textAlign: 'center',
        color: '#666',
        marginTop: 5,
    },
    table: {
        display: 'table',
        width: '100%',
        marginTop: 10,
        borderStyle: 'solid',
        borderWidth: 0.5,
        borderColor: '#bfbfbf',
    },
    tableRow: {
        flexDirection: 'row',
        minHeight: 20,
        alignItems: 'center',
    },
    tableColHeader: {
        backgroundColor: '#f0f0f0',
        borderStyle: 'solid',
        borderWidth: 0.5,
        borderColor: '#bfbfbf',
        padding: 4,
    },
    tableCol: {
        borderStyle: 'solid',
        borderWidth: 0.5,
        borderColor: '#bfbfbf',
        padding: 4,
    },
    tableCellHeader: {
        fontSize: 7,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    tableCell: {
        fontSize: 6,
        textAlign: 'left',
    },
    // Specific Column Widths (Total ~100%)
    colID: { width: '8%' },
    colName: { width: '14%' },
    colStatus: { width: '5%' },
    colNIC: { width: '9%' },
    colGender: { width: '5%' },
    colBirth: { width: '8%' },
    colContact: { width: '8%' },
    colEmergency: { width: '8%' },
    colAddress: { width: '13%' },
    colSpec: { width: '10%' },
    colExp: { width: '5%' },
    colAssign: { width: '10%' }, 
});

const TrainerDetailedPDF = ({ data, filters }) => {
    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page}>
                <View style={styles.header}>
                    <Text style={styles.title}>{COMPANY_NAME} - Detailed Trainer Report</Text>
                    <Text style={styles.subtitle}>
                        Generated on: {moment().format('YYYY-MM-DD HH:mm:ss')} | 
                        Records: {data.length}
                    </Text>
                </View>

                <View style={styles.table}>
                    {/* Header */}
                    <View style={[styles.tableRow, { backgroundColor: '#f0f0f0' }]}>
                        <View style={[styles.tableCol, styles.colID]}><Text style={styles.tableCellHeader}>Trainer ID</Text></View>
                        <View style={[styles.tableCol, styles.colName]}><Text style={styles.tableCellHeader}>Full Name</Text></View>
                        <View style={[styles.tableCol, styles.colStatus]}><Text style={styles.tableCellHeader}>Stat</Text></View>
                        <View style={[styles.tableCol, styles.colNIC]}><Text style={styles.tableCellHeader}>NIC</Text></View>
                        <View style={[styles.tableCol, styles.colGender]}><Text style={styles.tableCellHeader}>G</Text></View>
                        <View style={[styles.tableCol, styles.colBirth]}><Text style={styles.tableCellHeader}>Birthday</Text></View>
                        <View style={[styles.tableCol, styles.colContact]}><Text style={styles.tableCellHeader}>Contact</Text></View>
                        <View style={[styles.tableCol, styles.colEmergency]}><Text style={styles.tableCellHeader}>Emergency</Text></View>
                        <View style={[styles.tableCol, styles.colAddress]}><Text style={styles.tableCellHeader}>Address</Text></View>
                        <View style={[styles.tableCol, styles.colSpec]}><Text style={styles.tableCellHeader}>Specialization</Text></View>
                        <View style={[styles.tableCol, styles.colExp]}><Text style={styles.tableCellHeader}>Exp</Text></View>
                        <View style={[styles.tableCol, styles.colAssign]}><Text style={styles.tableCellHeader}>Memb</Text></View>
                    </View>

                    {/* Data Rows */}
                    {data.map((item, index) => (
                        <View key={index} style={styles.tableRow}>
                            <View style={[styles.tableCol, styles.colID]}><Text style={styles.tableCell}>{item.trainer_id}</Text></View>
                            <View style={[styles.tableCol, styles.colName]}><Text style={styles.tableCell}>{item.name}</Text></View>
                            <View style={[styles.tableCol, styles.colStatus]}><Text style={styles.tableCell}>{Number(item.status) === 1 ? 'A' : 'I'}</Text></View>
                            <View style={[styles.tableCol, styles.colNIC]}><Text style={styles.tableCell}>{item.nic}</Text></View>
                            <View style={[styles.tableCol, styles.colGender]}><Text style={styles.tableCell}>{item.gender}</Text></View>
                            <View style={[styles.tableCol, styles.colBirth]}><Text style={styles.tableCell}>{item.birthday ? moment(item.birthday).format('YYYY-MM-DD') : '-'}</Text></View>
                            <View style={[styles.tableCol, styles.colContact]}><Text style={styles.tableCell}>{item.contact_no}</Text></View>
                            <View style={[styles.tableCol, styles.colEmergency]}><Text style={styles.tableCell}>{item.emergency_contact}</Text></View>
                            <View style={[styles.tableCol, styles.colAddress]}><Text style={styles.tableCell}>{item.address}</Text></View>
                            <View style={[styles.tableCol, styles.colSpec]}><Text style={styles.tableCell}>{item.specialization}</Text></View>
                            <View style={[styles.tableCol, styles.colExp]}><Text style={styles.tableCell}>{item.experience ? `${item.experience}Y` : '-'}</Text></View>
                            <View style={[styles.tableCol, styles.colAssign]}><Text style={styles.tableCell}>{item.assigned_members || '-'}</Text></View>
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );
};

export default TrainerDetailedPDF;
